import React from "react";
import { useParams } from "react-router-dom";
import { actionsApi } from "../../services/api";
import type { RunQueryAction } from "../../types/node_action";
import ActionEditForm from "../../components/actions/ActionEditForm";

interface RunQueryActionEditPageProps {}

export default function RunQueryActionEditPage({}: RunQueryActionEditPageProps) {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [action, setAction] = React.useState<RunQueryAction | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const loadAction = async () => {
      if (!id) return;

      try {
        setLoading(true);
        setError(null);

        // For now, we'll need to find the action from the list
        // In a real implementation, you'd have a direct endpoint to get an action by ID
        const actions = await actionsApi.listRunQueryActions();
        const foundAction = actions.find((a) => a.id === Number(id));

        if (foundAction) {
          setAction(foundAction);
        } else {
          setError("Run query action not found");
        }
      } catch (e: any) {
        setError(e?.message || "Failed to load run query action");
      } finally {
        setLoading(false);
      }
    };

    loadAction();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center py-12">
            <div className="text-lg text-gray-600">
              Loading run query action...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center py-12">
            <div className="text-lg text-red-600">Error: {error}</div>
          </div>
        </div>
      </div>
    );
  }

  if (!action) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center py-12">
            <div className="text-lg text-gray-600">
              Run query action not found
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <ActionEditForm type="run_query" action={action} />;
}
